module.exports = __webpack_public_path__ + "static/media/home_hero.91bb4926.jpg";